import { render } from "./ListComentariosPreguntas.vue?vue&type=template&id=4b7e0dd4"
import script from "./ListComentariosPreguntas.vue?vue&type=script&lang=js"
export * from "./ListComentariosPreguntas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__